import { cn } from '@/utils/cn'
import { VisuallyHidden } from '@/components/ui'

export interface TypingIndicatorProps {
  className?: string
}

/**
 * Animated typing indicator shown when the agent is responding.
 * Includes screen reader announcement.
 */
export function TypingIndicator({ className }: TypingIndicatorProps) {
  return (
    <div
      className={cn('flex items-center gap-1 py-2', className)}
      role="status"
      aria-live="polite"
    >
      <VisuallyHidden>Assistant is typing</VisuallyHidden>

      <div className="flex items-center gap-1 rounded-full bg-gray-100 px-4 py-2">
        {[0, 1, 2].map((index) => (
          <span
            key={index}
            className={cn(
              'h-2 w-2 rounded-full bg-gray-400',
              'animate-typing-bounce'
            )}
            style={{
              animationDelay: `${index * 0.2}s`,
            }}
            aria-hidden="true"
          />
        ))}
      </div>
    </div>
  )
}
